import { createClient } from '@supabase/supabase-js';

// Fall back to harmless placeholders so the client can be constructed at build
// time (and during prerender) before real credentials are set in .env.local.
// Calls will simply fail at runtime until valid values are provided.
const supabaseUrl =
  process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey =
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ||
  'placeholder-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
